export type SortDirection = "ASC" | "DESC";

export type SortableColumn = "username" | "email" | "phoneNumber" | "createdAt" | "expirationDate";

export type TableSort = {
    column: SortableColumn;
    direction: SortDirection;
};

export const DEFAULT_SORT_DIRECTION_BY_COLUMN: Record<SortableColumn, SortDirection> = {
    username: "ASC",
    email: "ASC",
    phoneNumber: "ASC",
    createdAt: "DESC",
    expirationDate: "ASC",
};

export const getNextSort = (current: TableSort, clickedColumn: SortableColumn): TableSort => {
    if (current.column === clickedColumn) {
        return { column: clickedColumn, direction: current.direction === "ASC" ? "DESC" : "ASC" };
    }

    return { column: clickedColumn, direction: DEFAULT_SORT_DIRECTION_BY_COLUMN[clickedColumn] };
};
